<template>
	<div>
		<crop-filter
			v-model="filter"
			v-if="showFilter"
			v-on:close="showFilter = false"
			:show-city="false"
		/>

		<!-- Sticky Toolbar: Filterleiste UND Suchfeld pinnen gemeinsam unter dem gruenen Header
		     (top-[4.25rem]) — analog zum Status-Filter. So scrollt das Suchfeld nicht weg (auch im
		     gescrollten Zustand oeffenbar) und wandert nicht ueber den gruenen Header. z-10 haelt
		     die Toolbar ueber dem scrollenden Content. -->
		<div class="sticky top-[4.25rem] md:relative md:top-0 z-10 bg-gray-700">
			<div class="md:flex items-center">
			<!-- list filter -->
			<div
				:class="[
					'md:w-2/5 xl:w-1/3 border-r border-gray-500',
					showListOnMobile ? '' : 'hidden md:block',
				]"
			>
				<div class="flex justify-between space-x-4 px-4 sm:px-6 lg:px-6 py-4">
					<button
						class="relative px-2 py-1.5 flex items-center font-medium text-white bg-gray-500 hover:bg-gray-400 rounded-lg focus:ring-2 ring-gray-500"
						v-on:click.stop="showFilter = !showFilter"
					>
						<ui-icon
							class="flex-shrink-0 h-5 w-5"
							name="filter"
							stroke-width="2"
						/>
						<span
							class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-orange-50 transform translate-x-1/4 -translate-y-1/2 bg-orange rounded-full"
							v-if="activeFilterCount > 0"
							>{{ activeFilterCount }}</span
						>
					</button>

					<button
						class="px-2 py-1.5 flex items-center font-medium text-white bg-gray-500 hover:bg-gray-400 rounded-lg focus:ring-2 ring-gray-500"
						v-on:click.stop="showSearch = !showSearch"
					>
						<ui-icon
							class="flex-shrink-0 h-5 w-5"
							name="search"
							stroke-width="2"
						/>
						<span class="hidden sm:block lg:hidden ml-2 mr-1">{{
							__("Search")
						}}</span>
					</button>

					<ui-dropdown
						class="flex-grow min-w-0"
						dropdown-class="origin-top absolute left-0 mt-2 w-full rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
						button-class="pl-3 pr-2 py-1.5 w-full min-w-0 flex items-center justify-between relative
                                       font-medium text-gray-100 bg-gray-500 hover:bg-gray-400 rounded-lg
                                       active:bg-gray-400 focus:gray-400 focus:ring-2 ring-gray-500"
					>
						<template v-slot:button>
							<div class="flex-shrink flex-grow min-w-0 truncate text-left">
								{{ __("Status") }}
							</div>

							<ui-icon
								class="ml-2 flex-shrink-0 h-5 w-5"
								name="chevron-down"
								stroke-width="2"
							/>
						</template>

						<!-- Multi-Select: keine Auswahl = alle Status. -->
						<template v-slot:items>
							<label
								class="flex items-center whitespace-nowrap px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
								v-for="option in statusFilterOptions"
								:key="option.id"
							>
								<input
									type="checkbox"
									class="h-4 w-4 rounded text-orange-500 border-gray-300 focus:ring-orange-400"
									:checked="filter.statuses.includes(option.id)"
									v-on:change="toggleStatus(option.id)"
								/>
								<span class="ml-3 text-sm font-medium">{{ __(option.name) }}</span>
							</label>
						</template>
					</ui-dropdown>
				</div>
			</div>

			<!-- conversation title bar  -->

			<div
				:class="[
					' md:w-3/5 xl:w-2/3 px-4 sm:px-6 lg:px-6 py-4 flex space-x-4 justify-between',
					showListOnMobile ? 'hidden md:flex' : '',
				]"
			>
				<div
					class="flex md:-ml-4 space-x-4 items-baseline truncate"
					v-if="activeThread"
				>
					<button
						class="md:hidden flex-shrink pl-2 pr-2 xl:pr-4 py-1.5 font-medium text-white bg-gray-600 hover:bg-gray-400 rounded-lg flex items-center focus:ring-2 ring-gray-500"
						v-on:click.stop="toggleshowListOnMobile(true)"
					>
						<ui-icon
							class="flex-shrink-0 h-5 w-5"
							name="chevron-left"
							stroke-width="2"
						/>
					</button>
					<p class="text-gray-100 text-2xl font-medium truncate">
						{{ activeThread.counterpart.company_name }}
					</p>
					<p
						class="hidden md:block text-gray-200 font-medium truncate"
						v-if="!showContactInfo"
					>
						{{ activeThread.counterpart.name }}
					</p>
				</div>

				<button
					v-if="activeThread"
					v-on:click.stop="showContactInfo = !showContactInfo"
					class="relative whitespace-nowrap inline-flex items-center pl-4 pr-4 py-1.5 font-medium text-white bg-gray-600 hover:bg-gray-400 rounded-lg focus:ring-2 ring-gray-500"
				>
					<span v-if="!showContactInfo">{{ __("More info") }}</span>
					<span v-if="showContactInfo">{{ __("Close") }}</span>
				</button>
			</div>
		</div>

			<!-- Suche als Overlay: absolut unter der Bar (top-[100%]), damit das Oeffnen den
			     Sticky-Wrapper NICHT vergroessert — der Content darunter verrutscht nicht, die Suche
			     legt sich als Overlay darueber (geht bewusst ueber die Bar hinaus). Liegt in der
			     z-10-Toolbar (ueber dem Content) und pinnt mit der Bar. Einmal stabil hier statt in
			     List/EmptyState, damit das Feld ueber Reloads/Branch-Wechsel nicht un-/remountet
			     (kein Fokusverlust, kein Flacker-Toggle). -->
			<div
				class="absolute top-[100%] left-0 w-full md:w-2/5 xl:w-1/3"
				:class="showListOnMobile ? '' : 'hidden md:block'"
			>
				<thread-search-input
					:filter="filter"
					:show-search="showSearch"
					v-on:close="closeSearch"
				/>
			</div>
		</div>

		<div
			class="max-h-full flex-grow flex items-center justify-center bg-gray-100"
			v-if="isLoading"
		>
			<ui-loading-spinner />
		</div>
		<content-threads-empty-state
			class="max-h-full flex-grow flex bg-gray-100"
			v-else-if="threads.length === 0"
		/>
		<div
			class="md:overflow-hidden max-h-full flex-grow flex bg-gray-150"
			v-else
		>
			<thread-list
				:threads="threads"
				:activeThread="activeThread"
				:has-more="hasMore"
				:is-loading-more="isLoadingMore"
				v-on:load-more="loadMore"
				v-on:new-active-thread="setActiveThread"
				:show-list-on-mobile="showListOnMobile"
				v-on:toggle-show-list-on-mobile="toggleshowListOnMobile"
				:class="showListOnMobile ? '' : 'hidden md:block'"
			/>

			<thread-show-threads
				:showContactInfo="showContactInfo"
				:thread="activeThread"
				:key="activeThread ? activeThread.id : null"
				:show-list-on-mobile="showListOnMobile"
				v-on:toggle-show-list-on-mobile="toggleshowListOnMobile"
				:class="showListOnMobile ? 'hidden md:block' : ''"
				v-if="activeThread"
			/>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions");
import UiFilterSessionStorage from "../Ui/FilterSessionStorage.vue";

export default {
	mixins: [UiFilterSessionStorage],
	props: {
		initialStatuses: {
			type: Array,
			required: false,
			default: () => [],
		},
		initialActiveId: {
			type: Number,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			// Serverseitig gefilterte + paginierte Liste. Als Vue.observable, damit
			// Realtime-Updates (thread-update) sie mutieren koennen.
			threads: Vue.observable([]),
			activeThread: null,
			showListOnMobile: true,
			showSearch: false,
			showContactInfo: false,
			statusFilterOptions: options.threadStatusOptions,
			filter: Vue.observable({
				productGrades: [],
				productYears: [],
				dateType: [],
				monthType: {
					month_from: null,
					month_to: null,
				},
				locationModes: [],
				search: "",
				statuses: [...this.initialStatuses],
			}),
			showFilter: false,
			listPageYOffset: null,
			// Pagination + Ladezustand. Seitengroesse UND Offset liegen serverseitig
			// (Repository): das Frontend zaehlt nur Seiten. page = Anzahl erfolgreich
			// geladener Seiten (0 = noch keine), naechster Fetch = page + 1. Bewusst NICHT an
			// threads.length gekoppelt (das driftet bei Dedup/thread-update).
			page: 0,
			hasMore: false,
			isLoading: true,
			isLoadingMore: false,
			// Sequenz-Token gegen veraltete Antworten; lastLoadedKey (nur nach erfolgreichem Reset
			// gesetzt) dedupliziert Filter-Reloads. initialized-Gate: programmatische Filter-
			// Mutationen waehrend des Mounts loesen keinen zusaetzlichen Reload aus.
			contentRequestId: 0,
			lastLoadedKey: null,
			reloadTimer: null,
			initialized: false,
		};
	},
	computed: {
		activeFilterCount() {
			let count = 0;
			try {
				count =
					this.filter.productGrades.length +
					this.filter.productYears.length +
					this.filter.locationModes.length +
					this.filter.dateType.length;
			} catch (e) {}
			return count;
		},
		// Dedup-Schluessel fuer den Re-Fetch. this.filter enthaelt genau die filterrelevanten
		// Felder (keine Pagination) → direkt stringifizieren, keine zweite Feldliste pflegen.
		filterKey() {
			return JSON.stringify(this.filter);
		},
	},
	methods: {
		setActiveThread(newActiveThread) {
			this.activeThread = newActiveThread;
		},
		// Suche schliessen: Single Source (showSearch) bleibt hier im Parent. Leert zugleich den
		// Suchbegriff (der Filter-Watcher laedt neu). Loest die frueher im SearchInput per
		// Prop-Mutation verursachte Desync auf.
		closeSearch() {
			this.filter.search = "";
			this.showSearch = false;
		},
		// Status im Multi-Select an-/abwaehlen. Leere Auswahl = alle Status.
		toggleStatus(id) {
			let idx = this.filter.statuses.indexOf(id);
			if (idx === -1) {
				this.filter.statuses.push(id);
			} else {
				this.filter.statuses.splice(idx, 1);
			}
		},
		toggleshowListOnMobile(newVal) {
			// Scrollposition merken, damit die Rueckkehr aus einem Thread wieder passt.
			if (newVal == false) {
				this.listPageYOffset = window.pageYOffset;
			}

			this.showListOnMobile = newVal;

			if (newVal == true && this.listPageYOffset != null) {
				let pageYOffset = this.listPageYOffset;
				this.$nextTick(function () {
					window.scrollTo(0, pageYOffset);
				});
			}
		},
		/**
		 * Threadliste laden. reset=true ersetzt die Liste (Erstladen/Filterwechsel) und laedt
		 * Seite 1; reset=false haengt die naechste Seite an ("Mehr laden").
		 */
		loadContent(reset = true) {
			const requestId = ++this.contentRequestId;
			// Filter, fuer den dieser Request gilt — erst bei akzeptierter Antwort als geladen vermerkt.
			const requestedKey = this.filterKey;
			const page = reset ? 1 : this.page + 1;

			if (reset) {
				this.isLoading = true;
			} else {
				this.isLoadingMore = true;
			}

			axios
				// Seite reist als Pfad-Segment (threads/content/{page}), getrennt vom Filter-Body:
				// Pagination ist Routen-/Query-State, kein Filter.
				.post(this.$route("threads.content", { page }), this.filter)
				.then((response) => {
					if (requestId !== this.contentRequestId) {
						return;
					}

					const rows = response.data.threads ?? [];

					if (reset) {
						this.threads = Vue.observable(rows);
						// Erst jetzt gilt der Filter als geladen: ein gescheiterter oder ueberholter
						// Reset laesst lastLoadedKey stehen und wird beim naechsten Wechsel erneut geladen.
						this.lastLoadedKey = requestedKey;
					} else {
						// Defensiv gegen doppelte Threads (z.B. wenn ein per thread-update oben
						// eingefuegter Thread in einer Folgeseite erneut kommt): nur unbekannte ids
						// anhaengen. Verhindert doppelte :key in der Liste.
						const knownIds = new Set(this.threads.map((t) => t.id));
						rows.forEach((row) => {
							if (!knownIds.has(row.id)) {
								this.threads.push(row);
							}
						});
					}

					// Seite erst nach akzeptierter Antwort hochzaehlen: ein gescheiterter oder
					// ueberholter Request laesst page stehen und wird erneut versucht.
					this.page = page;
					this.hasMore = response.data.hasMore ?? false;

					this.selectActiveThread();
				})
				.finally(() => {
					if (requestId !== this.contentRequestId) {
						return;
					}

					this.isLoading = false;
					this.isLoadingMore = false;
				});
		},
		/**
		 * Naechste Seite anhaengen.
		 */
		loadMore() {
			if (this.isLoadingMore || !this.hasMore) {
				return;
			}

			this.loadContent(false);
		},
		/**
		 * Filterwechsel: entprellt neu laden (Offset-Reset). Ueberspringt den Fetch, wenn der
		 * entprellte Nettowechsel wieder beim aktuell geladenen Filter landet (filterKey ===
		 * lastLoadedKey). Mount- und sessionStorage-Restore laufen nicht hier durch, sondern werden
		 * vom initialized-Gate im filter-Watcher abgefangen.
		 */
		scheduleReload() {
			clearTimeout(this.reloadTimer);
			this.reloadTimer = setTimeout(() => {
				if (this.filterKey !== this.lastLoadedKey) {
					this.loadContent(true);
				}
			}, 300);
		},
		/**
		 * Bestimmt den anzuzeigenden Thread: bevorzugt den bereits aktiven bzw. per Deep-Link
		 * vorgegebenen (sofern in der geladenen Liste), sonst den ERSTEN der Liste. Leere Liste
		 * → keine Auswahl. Beim "Mehr laden" bleibt die Auswahl erhalten (der aktive Thread wird
		 * in der erweiterten Liste wiedergefunden). Mobile bleibt unberuehrt (showListOnMobile
		 * steuert dort die Ansicht).
		 */
		selectActiveThread() {
			let id = this.activeThread?.id ?? this.initialActiveId;
			let found = id != null ? this.threads.find((t) => t.id == id) : null;

			if (found) {
				this.activeThread = found;
				return;
			}

			this.activeThread = this.threads.length > 0 ? this.threads[0] : null;
		},
	},
	created() {
		let that = this;

		this.$bus.$on("thread-update", function (newThread) {
			let haveUpdated = false;
			that.threads.forEach(function (thread, idx) {
				if (thread.id == newThread.id) {
					that.threads.splice(idx, 1, newThread);
					haveUpdated = true;
				}
			});

			if (!haveUpdated) {
				that.threads.unshift(newThread);
			}

			if (newThread.id == that.activeThread?.id) {
				that.setActiveThread(newThread);
			}
		});
	},
	mounted() {
		// FilterSessionStorage-Mixin hat den Filter (falls vorhanden) bereits in mounted
		// wiederhergestellt (Mixin-mounted laeuft vor diesem). Veraltete/ungueltige Status
		// (z.B. das entfernte "ALL") rauswerfen, damit sie nicht ans Backend gehen.
		let validIds = this.statusFilterOptions.map((o) => o.id);
		this.filter.statuses = (this.filter.statuses || []).filter((s) =>
			validIds.includes(s)
		);

		if (this.initialActiveId) {
			// Deep-Link auf einen Thread: den vom Controller vorgewaehlten Status erzwingen
			// (Vorrang vor einem aus sessionStorage wiederhergestellten), damit der Ziel-Thread
			// im geladenen Set liegt.
			this.filter.statuses = [...this.initialStatuses];
			this.showListOnMobile = false;
		}

		this.loadContent(true);

		// Die Filter-Mutationen oben (Status-Cleanup / Deep-Link) haben den deep-Watcher bereits
		// eingereiht; er laeuft im anstehenden Flush, waehrend initialized noch false ist. Erst im
		// naechsten Tick auf true, damit dieser erste, programmatische Wechsel keinen zweiten Fetch
		// ausloest — unabhaengig davon, wie lange der Initial-Request dauert.
		this.$nextTick(() => {
			this.initialized = true;
		});
	},
	watch: {
		filter: {
			deep: true,
			handler() {
				if (!this.initialized) {
					return;
				}

				this.scheduleReload();
			},
		},
	},
};
</script>
